
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcLineGraph as ObcLineGraphElement} from '@oicl/openbridge-webcomponents/dist/bars-graphs/line-graph/line-graph.js';
 
 
 

 
 export const ObcLineGraph = createComponent({
   react: React,
   tagName: 'obc-line-graph',
   elementClass: ObcLineGraphElement,
   events: {
     
   }
  });
 
 